import FileSaver from 'file-saver';

export const exportAnalysisToFile = ({
  analysis,
  matrix,
  setShowLoadingOverlay,
  setDownloadErrorSnackbar,
  getAnalysisExcelDownload
}) => {
  setShowLoadingOverlay(true);

  const fileName = generateFileName(analysis, matrix);

  getAnalysisExcelDownload(analysis, matrix)
    .then((response) => {
      FileSaver.saveAs(response, fileName);
    })
    .finally(() => setShowLoadingOverlay(false))
    .catch((error) => setDownloadErrorSnackbar(`Download Failed: ${error}`));
};

const generateFileName = (analysis, matrix) => {
  const formatString = str => str?.replace(/[^a-z0-9]/gi, ' ')?.replace(/\s\s+/g, ' ')?.replace(/[^a-z0-9]/gi, '_');
  return `${formatString(analysis)}-${formatString(matrix)}`;
};